import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bulk-mail",
  "use": "bulk-mail-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"bulk-mail\">\n  <g fill-rule=\"evenodd\">\n    <path d=\"M22,6 L6,6 C4.9,6 4.01,6.9 4.01,8 L4,20 C4,21.1 4.9,22 6,22 L22,22 C23.1,22 24,21.1 24,20 L24,8 C24,6.9 23.1,6 22,6 Z M22,10 L14,15 L6,10 L6,8 L14,13 L22,8 L22,10 Z\" />\n    <path d=\"M14,2 L2,2 C0.9,2 0,2.9 0,4 L0,18 L2,18 L2,4 L14,4 L14,2 Z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol